




















import {Vue, Component, Watch} from 'vue-property-decorator'
import {Action, State} from 'vuex-class'
import sdk from '../lib/kepler/sdk'
import {PopupState, RootState} from '../store'

import LoginView from '../views/Login.vue'

import Container from './proxy/Container.vue'
import Layout from './proxy/Layout.vue'
import Button from './Button.vue'
import {EventBus} from '@/main'
import QuickRegistrationView from '../views/Flows/FlowQuickRegistration.vue'
import LoopingBG from '@/components/LoopingBG.vue'
import Flex from '@/components/proxy/Flex.vue'
import Img from '@/components/proxy/Image.vue'

@Component({
  components: {
    Img,
    Flex,
    LoopingBG,
    QuickRegistrationView,
    Layout,
    Button,
    Container,
  },
  name: 'IsLogged',
})
export default class IsLogged extends Vue {
  @Action('closeDialog') public closeDialog!: (index?: number) => void
  @Action('openPopup') public openPopup!: (popup: PopupState) => void

  protected isLogged: boolean = false

  protected mounted() {
    this.isLogged = this.logged()
    EventBus.$on('login', () => {
      this.isLogged = this.logged()
    })
  }

  protected login() {
    this.closeDialog(0)
    this.openPopup(new PopupState(LoginView, null, 'Login', false))
  }

  protected signUp() {
    this.closeDialog(0)
    this.openPopup(new PopupState(QuickRegistrationView, null, null, true))
  }

  protected logged() {
    return sdk.people.isLogged()
  }
}
